import axios from 'axios';
import { HOLD_WIP_SERVER_URL } from '../../config/env';

export default class AdminService {

    static getAllEmails () {
        return axios({
            method: 'get',
            url: HOLD_WIP_SERVER_URL + '/getAllEmails'
        })
    }

    static deleteEmail ( email ) {
        return axios({
            method: 'post',
            url: HOLD_WIP_SERVER_URL + '/deleteEmail',
            data: email
        })
    }

    static createEmail ( email ) {
        return axios({
            method: 'post',
            url: HOLD_WIP_SERVER_URL + '/createEmail',
            data: email,
        })
    }

    static updateEmail(emailJSON: string) {
        return axios({
            method: 'post',
            url: HOLD_WIP_SERVER_URL + '/updateEmail',
            data: emailJSON,
            headers: {
                'Content-Type': 'application/json'
            }
        })
    }

    static getEmailListByEmail(email: string) {
        return axios({
            method:'get',
            url: HOLD_WIP_SERVER_URL + "/getEmailListByEmail",
            params: { email: email }
        });
    }
}
